.tree {
  list-style: none;
  padding: 0;
  margin: 0;
  outline: none;
}

.item {
  display: flex;
  align-items: center;
  cursor: pointer;
  border-radius: var(--tuna-shape-radius-sm);
  min-height: 28px;
  outline: none;
}

.item:hover {
  background-color: var(--tuna-palette-action-hover);
}

.itemHighlighted {
  background-color: var(--tuna-palette-action-selected);
}

.expandIcon {
  display: inline-flex;
  width: 24px;
  height: 24px;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

/* Touch: 44px rows (GH #2406, WCAG 2.5.5); font unchanged, desktop stays dense */
@media (pointer: coarse) {
  .item {
    min-height: 44px;
  }

  /* A 44px toggle hit area; the icon inside stays 24px */
  .expandIcon {
    min-width: 44px;
    min-height: 44px;
  }
}

.expandIconHidden {
  visibility: hidden;
}

.group {
  list-style: none;
  padding-left: 16px;
  margin: 0;
}
